<script lang="ts">
  import { Col } from "sveltestrap";
  import data from "../../../../Data/Chat/Chat.json";
  import { isOpens } from "../../../../store";
  import ChatTabContent from "../ChatApp/ChatTabContent.svelte";
  let open: boolean = false;
  let selectId: string = "info-home-tab";
  const handletab = (id: string) => {
    selectId = id;
    if (selectId === id) {
      open = true;
    }
  };
  let setOpen: boolean;
  isOpens.subscribe((value) => {
    setOpen = value;
  });
</script>

{#if setOpen}
  <Col class="pl-xl-0 chat-menu show">
    <ul
      class="nav nav-tabs border-tab nav-primary"
      id="info-tab"
      role="tablist"
    >
      {#each data.chatmenudata as chatItem}
        <li class="nav-item">
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <a
            class="nav-link {selectId === chatItem.id && open ? 'active' : ''}"
            id={chatItem.id}
            on:click={() => handletab(chatItem.id)}>{chatItem.title}</a
          >
          <div class="material-border" />
        </li>
      {/each}
    </ul>
    <ChatTabContent getId={selectId} />
  </Col>
{/if}
